export default __webpack_public_path__ + "static/weare-3-553b2fa8a7a0382950fd51685b35f3ad.png";